import React from 'react';
import BoldText from "../text/BoldText";

class InterventionCustomer extends React.Component {

  render() {
    const {firstName, lastName, carBrand, carModel} = this.props;

    return (
      <div>
        <BoldText text={firstName + ' ' + lastName}/>
        <br/>
        {carBrand + ' ' + carModel}
      </div>
    )
  }
}

export default InterventionCustomer;
